import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview"

export default class ArticleLinkBoxUI extends Plugin {
  init() {
    const editor = this.editor
    const t = editor.t

    editor.ui.componentFactory.add("articleLinkBox", (locale) => {
      const command = editor.commands.get("insertArticleLinkBox")

      const buttonView = new ButtonView(locale)

      buttonView.set({
        label: t("記事リンク"),
        withText: true,
        toolTip: true,
      })

      buttonView.bind("isOn", "isEnabled").to(command, "value", "isEnabled")

      this.listenTo(buttonView, "execute", () =>
        editor.execute("insertArticleLinkBox")
      )

      return buttonView
    })
  }
}
